import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const Phone = (props: SvgProps) => (
  <Svg width={66.667} height={66.667} viewBox="0 0 50 50" {...props}>
    <Path d="M6.4 6.4C4.5 8.3 3 10.6 3 11.6 3.1 21.9 28.1 46.9 38.3 47c2.3 0 8.7-6.2 8.7-8.4 0-.9-2.5-3.2-5.5-5.3-5.5-3.6-5.6-3.6-8.9-2l-3.3 1.5-6.1-6.1-6-6.2 1.6-3.2c1.5-3.2 1.5-3.3-2.1-8.8-2.1-3-4.4-5.5-5.3-5.5-.9 0-3.1 1.5-5 3.4z" />
  </Svg>
);
export default Phone;
